import { render, staticRenderFns } from "./CiList.vue?vue&type=template&id=ecb30db4&scoped=true"
import script from "./CiList.vue?vue&type=script&lang=js"
export * from "./CiList.vue?vue&type=script&lang=js"
import style0 from "./CiList.vue?vue&type=style&index=0&id=ecb30db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb30db4",
  null
  
)

export default component.exports